export const USER = {
	CREATE_NEW_USER: 'Create New User',
	EDIT_USER: 'Edit User',
	DISPLAY_NAME: 'Display Name',
	USERNAME: 'Username',
	EMAIL: 'Email',
	PASSWORD: 'Password',
	SELECT_ROLE: 'Select Role',
	SELECT_COMPANY: 'Select Company',
	MODULE_PERMISSIONS: 'Module Permission',
	ACCESS_TO_ALL: 'Access to All',
	ACCESS_TO_CUSTOM: 'Access to Custom',
	MODULE_LIST: 'Module List',
	CREATE: 'Create',
	UPDATE: 'Update',
	VIEW: 'View',
	DELETE: 'Delete',
};
